
export {FirstDayOfWeek} from '@clayui/date-picker';
import __x__ from '@clayui/date-picker';export default __x__;